import { format } from 'date-fns-tz';

export default function getHourFromDate(date: Date) {
  return format(new Date(date), 'yyyy-MM-dd - HH:mm');
}
